module.exports = __webpack_public_path__ + "img/DE01657.b0f5dd99.png";